"use client";

import React from "react";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface CastrationSelectionProps {
  isCastrated: boolean | null;
  setIsCastrated: (value: boolean | null) => void;
  error: string;
  isLoading: boolean;
  groupRef: React.RefObject<HTMLDivElement>;
  petName: string;
}

const CastrationSelection: React.FC<CastrationSelectionProps> = ({
  isCastrated,
  setIsCastrated,
  error,
  isLoading,
  groupRef,
  petName,
}) => {
  const { t } = useTranslation();


  return (
    <div className="space-y-2" ref={groupRef}>
      <Label htmlFor="is-castrated">
        {petName ? t("petDetails.isCastrated", { petName: petName}) : t("petDetails.isCastratedUndefined") }</Label>
      <div className="flex gap-2">
        <Button
          variant={isCastrated === true ? "default" : "outline"}
          onClick={() => setIsCastrated(true)}
          className={cn(
            "flex-1",
            isCastrated === true && "bg-primary text-primary-foreground"
          )}
          disabled={isLoading}
        >
          {t("common.yes")}
        </Button>
        <Button
          variant={isCastrated === false ? "default" : "outline"}
          onClick={() => setIsCastrated(false)}
          className={cn(
            "flex-1",
            isCastrated === false && "bg-primary text-primary-foreground"
          )}
          disabled={isLoading}
        >
          {t("common.no")}
        </Button>
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default CastrationSelection;
